export function postcodeValidator() {
    return function (control) {
        var patten = new RegExp(/[A-Z]{1,2}[0-9]{1,2}[A-Z]?\s?[0-9][A-Z]{2}/i);
        return (!control.value || patten.test(control.value)) ? null : { postcodeValidator: { value: control.value } };
    };
}
var ValidPostcodeDirective = (function () {
    function ValidPostcodeDirective() {
    }
    ValidPostcodeDirective.prototype.validate = function (control) {
        return postcodeValidator()(control);
    };
    return ValidPostcodeDirective;
}());
export { ValidPostcodeDirective };



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/shared/valid-postcode.directive.ts.pre-build-optimizer.js